<template>

  <div>
    <b-modal
      v-if="forceModal || (Object.keys(formSchema).length < 7 && !forceSide)"
      v-model="modalOpen"
      footer-class="removed"
      centered
      no-close-on-backdrop
      v-bind="$attrs"
      v-on="$listeners"
    >
      <slot name="body">
        <validation-observer ref="FormValidation">
          <b-form @submit.prevent="onSubmit">
            <b-row>
              <b-col v-for="(field, key) in formSchema" :key="key" cols="12">
                <slot :name="field.key" v-bind:form="form" />
                <template v-if="field.component">
                  <component
                    v-if="field.numberModel"
                    :is="field.component"
                    v-bind="field.attrs"
                    v-on="field.listeners"
                    v-model.number="form[field.key]"
                  />
                  <component
                    v-else
                    :is="field.component"
                    v-bind="field.attrs"
                    v-on="field.listeners"
                    v-model="form[field.key]"
                  />
                </template>
              </b-col>
            </b-row>
            <hr />
            <b-row class="justify-content-end px-1">
              <b-button class="mx-1" @click="modalOpen = false" v-if="!BCansel">
                <feather-icon icon="XIcon" class="mr-50" />
                إلغاء
              </b-button>
              <loader-btn
                :disabled="!isFormValid"
                :label="confirmLabel"
                :icon="confirmIcon"
                variant="success"
                :loading="loading"
                type="submit"
              />
            </b-row>
          </b-form>
        </validation-observer>
      </slot>
    </b-modal>
    <b-sidebar
      v-else
      v-model="modalOpen"
      width="500px"
      id="edit-sidebar"
      shadow
      bg-variant="white"
      backdrop
    >
      <h2 class="px-2">{{ $attrs.title }}</h2>
      <hr />
      <validation-observer ref="FormValidation">
        <b-form class="px-2 py-50" @submit.prevent="onSubmit">
          <slot name="body">
            <b-row>
              <b-col v-for="(field, key) in formSchema" :key="key" cols="12">
                <slot :name="key" v-bind:form="form" />
                <template v-if="field.component">
                  <component
                    v-if="field.numberModel"
                    :is="field.component"
                    v-bind="field.attrs"
                    v-on="field.listeners"
                    v-model.number="form[field.key]"
                  />
                  <component
                    v-else
                    :is="field.component"
                    v-bind="field.attrs"
                    v-on="field.listeners"
                    v-model="form[field.key]"
                    @validationChanged="isFormValid = $event"
                  />
                </template>
              </b-col>
            </b-row>
          </slot>

          <hr />
          <b-row class="justify-content-end mt-auto px-1">
            <b-button class="mx-1" @click="modalOpen = false">
              <feather-icon icon="XIcon" class="mr-25" />
              إلغاء
            </b-button>
            <loader-btn
              :disabled="!isFormValid"
              :label="confirmLabel"
              :icon="confirmIcon"
              variant="success"
              :loading="loading"
              type="submit"
            />
          </b-row>
        </b-form>
      </validation-observer>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BModal,
  BRow,
  BCol,
  BForm,
  BButton,
  BSidebar,
  BFormCheckbox,
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";

export default {
  props: {
    formSchema: Object,
    value: Boolean,
    btnLabel: String,
    loading: Boolean,
    forceSide: {
      type: Boolean,
      default: () => false,
    },
    forceModal: {
      type: Boolean,
      default: () => false,
    },
    BCansel: {
      type: Boolean,
      default: () => false,
    },
    confirmLabel: String,
    confirmIcon: String,
  },
  components: {
    BModal,
    BRow,
    BCol,
    ValidationObserver,
    BForm,
    BButton,
    BSidebar,
    BFormCheckbox,
    FormInput: () => import("@/components/form-input/index.vue"),
    IconSelect: () => import("@/components/IconSelect.vue"),
    FormFile: () => import("@/components/form-file"),
    FormTextarea: () => import("@/components/form-textarea"),
    FormSelect: () => import("@/components/form-select"),
    FormMultiDatepicker: () => import("@/components/form-multi-datepicker"),
    FormDatepicker: () => import("@/components/form-datepicker"),
    LoaderBtn: () => import("@/components/loader-btn.vue"),
    VSelect: () => import("vue-select"),
    FormMask: () => import("@/components/form-mask/index.vue"),
    FormCleave: () => import("@/components/FormCleave.vue"),
    FormAutocomplete: () => import("./form-autocomplete/index.vue"),
    FormFileInput: () => import("./FormFileInput.vue"),
    FormPassword: () => import("./FormPassword.vue"),
    UsernameInput: () => import("./UsernameInput.vue"),
    EmailInput: () => import("./EmailInput.vue"),
    PhoneInput: () => import("./PhoneInput.vue"),
    MobileInput: () => import("./MobileInput.vue"),
    FormCurrency: () => import("./FormCurrency.vue"),
    FormImageInput: () => import("./FormImageInput.vue"),
    GeneratePassword: () => import("@/components/generate-password/index.vue"),
  },
  data() {
    return {
      form: {},
      isFormValid: true,
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  watch: {
    modalOpen(val) {
      if (!val) {
        requestAnimationFrame(() => {
          this.form = {};
          this.$refs.FormValidation.reset();
        });
      }
    },
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
    },
    async onSubmit() {
      await this.$refs.FormValidation.validate().then(async (success) => {
        if (success) {
          if (this.isFormValid) this.$emit("confirm", this.form);
        }
      });
    },
  },
};
</script>
